/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IDeleteInternalRegulationObligationRuleControlMutationVariables = Types.Exact<{
  input: Types.IDeleteInternalRegulationObligationRuleControlInput;
}>;

export type IDeleteInternalRegulationObligationRuleControlMutation = {
  __typename?: 'Mutation';
  deleteInternalRegulationObligationRuleControl: {
    __typename?: 'InternalRegulationObligationRuleControl';
    id: string;
    regulationObligationRuleId: string;
    controlId: string;
  };
};

export const DeleteInternalRegulationObligationRuleControlDocument = gql`
  mutation DeleteInternalRegulationObligationRuleControl($input: DeleteInternalRegulationObligationRuleControlInput!) {
    deleteInternalRegulationObligationRuleControl(input: $input) {
      id
      regulationObligationRuleId
      controlId
    }
  }
`;
export type IDeleteInternalRegulationObligationRuleControlMutationFn = Apollo.MutationFunction<
  IDeleteInternalRegulationObligationRuleControlMutation,
  IDeleteInternalRegulationObligationRuleControlMutationVariables
>;

/**
 * __useDeleteInternalRegulationObligationRuleControlMutation__
 *
 * To run a mutation, you first call `useDeleteInternalRegulationObligationRuleControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInternalRegulationObligationRuleControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInternalRegulationObligationRuleControlMutation, { data, loading, error }] = useDeleteInternalRegulationObligationRuleControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteInternalRegulationObligationRuleControlMutation(
  baseOptions?: Apollo.MutationHookOptions<
    IDeleteInternalRegulationObligationRuleControlMutation,
    IDeleteInternalRegulationObligationRuleControlMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    IDeleteInternalRegulationObligationRuleControlMutation,
    IDeleteInternalRegulationObligationRuleControlMutationVariables
  >(DeleteInternalRegulationObligationRuleControlDocument, options);
}
export type DeleteInternalRegulationObligationRuleControlMutationHookResult = ReturnType<
  typeof useDeleteInternalRegulationObligationRuleControlMutation
>;
export type DeleteInternalRegulationObligationRuleControlMutationResult =
  Apollo.MutationResult<IDeleteInternalRegulationObligationRuleControlMutation>;
export type DeleteInternalRegulationObligationRuleControlMutationOptions = Apollo.BaseMutationOptions<
  IDeleteInternalRegulationObligationRuleControlMutation,
  IDeleteInternalRegulationObligationRuleControlMutationVariables
>;
